import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyEventManagementServices = {
  //Event Column
  addNewStudyEventColumn,
  updateStudyEventColumnData,
  deleteStudyEventColumnData,
  softDeleteRestoreStudyEventColumn,
  getStudyEventColumnData,

  //Event Row
  addNewStudyEventRow,
  uploadStudyEventRow,
  updateStudyEventRowData,
  deleteStudyEventRowData,
  softDeleteRestoreStudyEventRow,
  getStudyEventRowData,
  exportStudyEventRowJsonData,
  getHeighestVersionEventRowHistory,
  getStudyEventAuditTrials,

  //Event Schema
  addUpdateStudyEventSchema,
  assignUnassignStudySiteSchema,
  findAssignSchemainSite,
  addUpdateStudySpecialEventSchema,
  deleteStudyEventSchema,
  updateStatusStudyEventSchema,
  getStudyEventSchema,
  findAssignedEventForm,
  getSchemaEventForms,
  findInitiatedEventForm,
  findSpecialEventForm,
  assignStudyEventSchemaInitiate,
  unassignStudyEventSchemaInitiate,
};

// Get Study Event Column
async function getStudyEventColumnData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEventColumnData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEventColumnData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Event Column
async function addNewStudyEventColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyEventColumn`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Event Column
async function updateStudyEventColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyEventColumnData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Event Column
async function softDeleteRestoreStudyEventColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyEventColumn`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Event Column
async function deleteStudyEventColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyEventColumnData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Event Row
async function getStudyEventRowData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEventRow/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEventRow/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Export Study Event Row Json Data
async function exportStudyEventRowJsonData(studyId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}exportStudyEventRowJsonData/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Add New Study Event Row
async function addNewStudyEventRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyEventRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// // Upload Event Study Event Row
async function uploadStudyEventRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}uploadStudyEventRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Event Row
async function updateStudyEventRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyEventRowData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Event Row
async function softDeleteRestoreStudyEventRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyEventRow`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Event Row
async function deleteStudyEventRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyEventRowData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Event Row Heighest version
async function getHeighestVersionEventRowHistory(studyId, eventId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getHeighestVersionEventRowHistory/${studyId}/${eventId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Event Row
async function getStudyEventAuditTrials(studyId, eventId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyEventAuditTrials/${studyId}/${eventId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Add Update Study Event Schema
async function addUpdateStudyEventSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateStudyEventSchema`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Assign and unassign Study Site Schema
async function assignUnassignStudySiteSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignUnassignStudySiteSchema`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Assign & unasssign Study Special Event Schema
async function addUpdateStudySpecialEventSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateStudySpecialEventSchema`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Study Event Schema
async function updateStatusStudyEventSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStatusStudyEventSchema`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Event Schema
async function deleteStudyEventSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyEventSchema`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Event Schema
async function getStudyEventSchema(status, studyId, siteId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyEventSchema/${status}/${studyId}/${siteId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Find Assigned Event Form
async function findAssignedEventForm(studyId, formId, schemaId, formVersion) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}findAssignedEventForm/${studyId}/${formId}/${schemaId}/${formVersion}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Find Assigned Schema in Site
async function findAssignSchemainSite(studyId, siteId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}findAssignSchemainSite/${studyId}/${siteId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Find Form Based on Schema and Event
async function getSchemaEventForms(studyId, schemaId, eventId, timePointId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSchemaEventForms/${studyId}/${schemaId}/${eventId}/${timePointId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Find Initiated Event Form
async function findInitiatedEventForm(studyId, formId, schemaId, formVersion) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}findInitiatedEventForm/${studyId}/${formId}/${schemaId}/${formVersion}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Find Special Event Form
async function findSpecialEventForm(studyId, formId, formVersion) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}findSpecialEventForm/${studyId}/${formId}/${formVersion}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// // Assign and unassign Study Event Schema Initiate
async function assignStudyEventSchemaInitiate(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignStudyEventSchemaInitiate`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// // Unassign and unassign Study Event Schema Initiate
async function unassignStudyEventSchemaInitiate(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}unassignStudyEventSchemaInitiate`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}